export default defineNuxtPlugin(() => {
  const { initialize } = useIssue492AbTest()
  initialize()
})
